import { DataFieldRuleValidator } from "./types";

export const dataFieldReadOnly: DataFieldRuleValidator = {
	validate: () => {
		return true;
	},

	getErrorMessage: ({ t }) => {
		return t("Field is not updatable");
	},
};
